<template>
  <div id="app">
    <v-app id="app2" xs>
      <v-content>
        <v-container flex class="pa-0">
          <v-toolbar app flat v-if="sessionValid===true">
            <div class="toolbar__items app-logo-toolbar">{{appTitle}}</div>
            <v-spacer></v-spacer>
            <v-toolbar-items class>
              <v-btn small to="/home" flat>
                <v-icon>home</v-icon>
              </v-btn>
              <v-btn to="/stats" flat>
                <v-icon>poll</v-icon>
              </v-btn>
              <v-btn to="/help" flat>
                <v-icon>info</v-icon>
              </v-btn>
              <v-menu offset-x offset-y>
                <v-btn slot="activator" flat>
                  <v-icon>account_box</v-icon>
                </v-btn>
                <v-list flat>
                  <v-list-tile to="/user">
                    <v-list-tile-title>Profile</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile to="/help/admin" v-if="userGroup=='ampsVoiceTrackerAdmin'">
                    <v-list-tile-title>Edit Help</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile to="/stats/admin" v-if="userGroup=='ampsVoiceTrackerAdmin'">
                    <v-list-tile-title>Stats Admin</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile to="/logout">
                    <v-list-tile-title>Logout</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-toolbar-items>
          </v-toolbar>
          <router-view v-if="sessionValid===true"></router-view>
          <voice-login v-if="sessionValid!==true"></voice-login>
        </v-container>
      </v-content>
    </v-app>
  </div>
</template>

<script>
import LoginService from "./components/LoginService.js";
import AppConst from "./components/AppConst.js";

var activityTypesDefaults = AppConst.activityTypesDefaults;
var activityIntensityTypesDefaults = AppConst.activityIntensityTypesDefaults;
var appTitleLocal = AppConst.appTitle;
var activityLogExamples = AppConst.actLogExampleData;

localStorage.activityTypes = activityTypesDefaults;
localStorage.activityIntensityTypes = activityIntensityTypesDefaults;
localStorage.appTitleLocal = appTitleLocal;
localStorage.activityLogExamples = activityLogExamples;

//NEEDS IF?ELSE HERE TO HAND LOCAL VALUES

import Login from "./components/Login.vue";

export default {
  name: "app",
  data() {
    return {
      sessionValid: "",
      userGroup: localStorage.userGroup,
      appTitle: appTitleLocal,
      hydrated: false
    };
  },
  head: {
    meta: [{ name: "application-name", content: appTitleLocal }]
  },
  async mounted(that = this) {
    await this.$apollo.provider.defaultClient.hydrated();
    this.hydrated = true;
    LoginService.getSession(that, function(data) {
      that.sessionValid = data;
      localStorage.sessionValid = data;
      that.userGroup = localStorage.userGroup;
      console.log;
    });
  },
  components: {
    "voice-login": Login
  },
  localStorage: {
    userSub: {
      type: String,
      default: ""
    },
    userGroup: {
      type: String,
      default: ""
    },
    email: {
      type: String,
      default: ""
    },
    username: {
      type: String,
      default: ""
    },
    currentDate: {
      type: Object,
      default: AppConst.today
    },
    activityTypeValues: {
      type: Object,
      default: activityTypesDefaults
    },
    activityIntensityTypeValues: {
      type: Object,
      default: activityIntensityTypesDefaults
    },
    sessionValid: {
      type: Object,
      default: ""
    },
    voiceFeelingSelected: {
      type: String,
      default: ""
    },
    vocalActivityTotal: {
      type: Number,
      default: parseInt(0)
    },
    waterConsumedValue: {
      type: Number,
      default: parseInt(0)
    },
    napsTakenValue: {
      type: Number,
      default: parseInt(0)
    },
    voiceDescriptive: {
      type: String,
      default: ""
    },
    age: {
      type: String,
      default: ""
    },
    genderType: {
      type: String,
      default: ""
    },
    voiceType: {
      type: String,
      default: ""
    },
    goals: {
      type: String,
      default: ""
    },
    singerType: {
      type: String,
      default: ""
    },
    sickMarkerValue: {
      type: String,
      default: "false"
    },
    currentDateSick: {
      type: String,
      default: ""
    },
    actLogExample: {
      type: Object,
      default: activityLogExamples
    },
    dialog: {
      type: String,
      default: "false"
    },
    totalDailyAllotment: {
      type: Number,
      default: parseInt(0)
    },
    currentDateVoiceFeelID: {
      type: String,
      default: ""
    }
  }
};
</script>
<style lang="css">
@import "/styles.css";
</style>
<style>
.toolbar .btn {
  min-width: 20px;
}

.app-logo-toolbar {
  display: flex;
  text-indent: -9999em;
  overflow: hidden;
  min-width: 56px;
  background: url(/app-logo-toolbar.png);
  background-size: 50px 50px;
  background-position: center;
  background-repeat: no-repeat;
}
.container.flex {
  max-width: 970px;
}
</style>





// WEBPACK FOOTER //
// src/App.vue